var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dashboardLoading)?_c('div',{staticClass:"text-center py-5"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_c('v-col',{attrs:{"cols":"12"}},[_c('SmallBoxes'),_c('Charts')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }